import i18next from "i18next";

/**
 * Translates error messages using error keys
 * @param {string} key - The key from API response
 * @returns {string} Translated message
 */
export const translateErrorMessage = (key) => {
	// Use i18next to translate the message key
	// If translation is missing, i18next will return the key itself
	return i18next.t(key, { defaultValue: key });
};

/**
 * Handles API error responses
 * @param {Error} error - Error object from API response
 * @returns {string} Translated error message
 */
export const handleApiError = (error) => {
	// Extract the error key from the response
	const errorKey = error?.response?.data?.message || "INTERNAL_SERVER_ERROR";
	return translateErrorMessage(errorKey);
};

const errorHandler = {
	translateErrorMessage,
	handleApiError,
};

export default errorHandler;
